import { render, staticRenderFns } from "./CompetitorLinks.vue?vue&type=template&id=b721b084&scoped=true"
import script from "./CompetitorLinks.vue?vue&type=script&lang=js"
export * from "./CompetitorLinks.vue?vue&type=script&lang=js"
import style0 from "./CompetitorLinks.vue?vue&type=style&index=0&id=b721b084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b721b084",
  null
  
)

export default component.exports